function getAllMenus() {
    return [
        {
            id: 100,
            text: "Home",
            url: "/home",
            icon: "grid",
            subMenus: [],
            cssClass: [""],
            selected: false,
            visible: true,
        },
        {
            id: 200,
            text: "Insurance",
            url: "/revenue_insights",
            altUrls: ["/", "/home"],
            icon: "car",
            subMenus: [
                {
                    id: 205,
                    text: "Revenue Insights",
                    url: "/revenue_insights",
                    altUrls: ["/", "/home"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 216,
                    text: "Auction Insights",
                    url: "/auction_insights",
                    subMenus: [],
                    cssClass: ["i-cat"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 217,
                    text: "Auction Health",
                    url: "/auction_delivery_health",
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 218,
                    text: "Auction Distribution",
                    url: "/auction_result_distribution",
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
            ],
            cssClass: ["i-config"],
            selected: false,
            visible: true,
        },
        /*    {
              id: 300,
               text: "Mortgage",
               url: "/mortgage_export",
               altUrls: [],
               icon: "home",
               subMenus: [
                   {
                       id: 302,
                       text: "Export",
                       url: "/mortgage_export",
                       subMenus: [],
                       cssClass: ["i-report"],
                       selected: false,
                       visible: true,
                   },
               ],
               cssClass: ["i-report"],
               selected: false,
               visible: true,
           }, */
        {
            id: 400,
            text: "Recruiting",
            url: "/admin_leads",
            altUrls: [],
            icon: "users",
            subMenus: [
                {
                    id: 402,
                    text: "Admin Leads",
                    url: "/admin_leads",
                    altUrls: ["/admin/leads"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 405,
                    text: "Question Banks",
                    url: "/question_banks",
                    altUrls: ["/admin/questionBanks", "/admin/questionBank/new", "/admin/questionBank/:id", "/admin/recruitingQuestions", "/admin/recruitingQuestion/new", "/admin/recruitingQuestion/:id"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 408,
                    text: "Partners",
                    url: "/partners",
                    altUrls: ["/admin/offerManagement", "/admin/offerManagement/new", "/admin/offerManagement/:id", "/admin/leadQuestion/new", "/admin/leadQuestion/:id"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 411,
                    text: "Creatives",
                    url: "/creatives",
                    altUrls: ["/admin/creativeList", "/admin/creative/new", "/admin/creative/:id"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 414,
                    text: "Contracts",
                    url: "/contracts",
                    altUrls: ["/admin/contracts", "/admin/contract/new", "/admin/contract/:id", "/admin/contract-duplicate/:id"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
                {
                    id: 417,
                    text: "Transmissions",
                    url: "/transmissions",
                    altUrls: ["/admin/transmissions", "/admin/transmission/new", "/admin/transmission/:id", "/admin/transmissionGroups", "/admin/transmissionGroup/:id"],
                    subMenus: [],
                    cssClass: ["i-report"],
                    selected: false,
                    visible: true,
                },
            ],
            cssClass: ["i-report"],
            selected: false,
            visible: true,
        },
    ];
}
function isPathMatch(pathName, item) {
    const urls = [...(item.altUrls || []), item.url];
    return urls.some((url) => isRouteMatch(pathName, url));
}
function isRouteMatch(pathName, route) {
    if (pathName === route) {
        return true;
    }
    if (!route.includes("/:")) {
        return false;
    }
    const pathParts = pathName.split("/").filter(Boolean);
    const routeParts = route.split("/").filter(Boolean);
    if (pathParts.length !== routeParts.length) {
        return false;
    }
    return routeParts.every((routePart, index) => routePart.startsWith(":") || routePart === pathParts[index]);
}
export function getSectionNavLinks(pathName = document.location.pathname) {
    for (const menu of getAllMenus()) {
        if (menu.subMenus.length === 0) {
            continue;
        }
        const onSection = isPathMatch(pathName, menu) ||
            menu.subMenus.some((subMenu) => isPathMatch(pathName, subMenu));
        if (!onSection) {
            continue;
        }
        return menu.subMenus
            .filter((item) => item.visible !== false)
            .map((item) => ({
            text: item.text,
            url: item.url,
            isActive: isPathMatch(pathName, item),
        }));
    }
    return [];
}
export function getTopLevelNavLinks() {
    return getAllMenus()
        .filter((menu) => menu.visible !== false && menu.id !== 100)
        .map((menu) => ({
        text: menu.text,
        url: menu.subMenus[0]?.url ?? menu.url,
        isActive: false,
    }));
}
export function getActiveSectionLabel(pathName = document.location.pathname) {
    for (const menu of getAllMenus()) {
        if (menu.subMenus.length === 0) {
            continue;
        }
        if (isPathMatch(pathName, menu) ||
            menu.subMenus.some((subMenu) => isPathMatch(pathName, subMenu))) {
            return menu.text;
        }
    }
    return getActiveMenuLabel(pathName);
}
export function getMenusWithSelection(pathName = document.location.pathname) {
    const menus = getAllMenus();
    let topLevelMatch = false;
    for (const menu of menus) {
        const menuUrls = [...(menu.altUrls || []), menu.url];
        menuUrls.forEach((url) => {
            if (pathName === url) {
                topLevelMatch = true;
            }
        });
        for (const subMenu of menu.subMenus) {
            const subMenuUrls = [...(subMenu.altUrls || []), subMenu.url];
            for (const url of subMenuUrls) {
                if (pathName === url) {
                    menu.selected = true;
                    subMenu.selected = true;
                    return menus;
                }
            }
        }
        if (topLevelMatch) {
            menu.selected = true;
            return menus;
        }
    }
    return menus;
}
export function getSelectedSubMenus(menus) {
    for (const menu of menus) {
        if (menu.selected) {
            return menu.subMenus;
        }
    }
    return [];
}
export function getActiveMenuLabel(pathName = document.location.pathname) {
    const menus = getMenusWithSelection(pathName);
    for (const menu of menus) {
        for (const subMenu of menu.subMenus) {
            if (subMenu.selected) {
                return subMenu.text;
            }
        }
        if (menu.selected) {
            return menu.text;
        }
    }
    return "Page";
}
